import { useTranslation } from 'react-i18next';
import { isApiError } from '../../api/errors';
import { ForbiddenPage } from './ForbiddenPage';
import { NotFoundPage } from './NotFoundPage';
import { ErrorSummary } from '../../components/idsk';

/** Renders a failed query: 403/404 pages or a generic error summary. */
export function QueryError({ error, asPage }: { error: unknown; asPage?: boolean }) {
  const { t } = useTranslation();
  if (asPage && isApiError(error) && error.status === 404) return <NotFoundPage />;
  if (asPage && isApiError(error) && error.status === 403) return <ForbiddenPage />;
  const message = isApiError(error) ? error.message : t('errors.unexpected');
  return <ErrorSummary title={t('errors.loadFailed')} errors={[{ text: message }]} />;
}
